import type { SVGProps } from "react";
export default function InfoCircleSvg(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="none"
      viewBox="0 0 16 16"
      className="flex shrink-0 grow-0"
      {...props}
    >
      <path
        fill="#6F6E6E"
        d="M8 0a8 8 0 1 0 8 8 8.01 8.01 0 0 0-8-8m0 14.77A6.77 6.77 0 1 1 14.77 8 6.776 6.776 0 0 1 8 14.77m1.23-3.078a.615.615 0 0 1-.615.616 1.23 1.23 0 0 1-1.23-1.231V8a.615.615 0 0 1 0-1.23A1.23 1.23 0 0 1 8.615 8v3.077a.615.615 0 0 1 .616.615M6.77 4.615a.923.923 0 1 1 1.845 0 .923.923 0 0 1-1.846 0"
      />
    </svg>
  );
}
